import {useEffect} from "react";
import {Navigate, Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";
import styles from "./HomeLayout.module.scss";

function HomeLayout() {
    const {user, logout} = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const pathname = location.pathname;
    const isPublicPage = pathname === '/privacy-policy' || pathname === '/terms-of-service';

    useEffect(() => {
        if (user && pathname.startsWith("/verify-user/")) {
            logout();
            navigate(pathname, {replace: true});
        }
    }, [user, pathname, logout, navigate]);

    if (user && !isPublicPage) {
        return <Navigate to="/app/dashboard" replace/>;
    }

    return (
        <div className={styles.container}>
            <Outlet/>
        </div>
    );
}

export {HomeLayout};
